"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const actionTypes = require("../../actionTypes/management/projectUsers");
//#endregion
//#region INITIAL STATE
exports.initialState = {
    selectedProject: undefined,
    userSearchString: '',
    status: 'STANDBY',
    removeStatus: 'STANDBY',
    result: [],
    selected: []
};
//#endregion
//#region LENS
const selectedProjectLens = monocle.Lens.fromProp('selectedProject');
const userSearchStringLens = monocle.Lens.fromProp('userSearchString');
const removeStatusLens = monocle.Lens.fromProp('removeStatus');
const statusLens = monocle.Lens.fromProp('status');
const resultLens = monocle.Lens.fromProp('result');
const selectedLens = monocle.Lens.fromProp('selected');
//#endregion
//#region REDUCER
const methods = {};
exports.methods = methods;
methods[actionTypes.SELECT_PROJECT] = (state, action) => selectedProjectLens.set(action.payload)(state);
methods[actionTypes.SET_USER_SEARCHING_STRING] = (state, action) => userSearchStringLens.set(action.payload)(state);
methods[actionTypes.FETCH_REQUEST] = (state) => statusLens.set('FETCHING')(state);
methods[actionTypes.FETCH_SUCCESS] = (state, action) => fp.function.compose(statusLens.set('FETCHED'), resultLens.set(action.payload))(state);
methods[actionTypes.FETCH_FAILED] = (state) => statusLens.set('FAILED')(state);
methods[actionTypes.TOGGLE_SELECT] = (state, action) => {
    if (action.payload.status) {
        return selectedLens.modify((x) => action.payload.items.reduce((acc, item) => {
            if (acc.findIndex((z) => z.project.id === item.project.id && z.user.id === item.user.id) === -1) {
                acc.push(item);
            }
            return acc;
        }, [...x]))(state);
    }
    return selectedLens.modify((x) => x.filter((z) => action.payload.items.findIndex((v) => v.project.id === z.project.id && v.user.id === z.user.id) === -1))(state);
};
methods[actionTypes.REMOVE_REQUEST] = (state) => removeStatusLens.set('FETCHING')(state);
methods[actionTypes.REMOVE_SUCCESS] = (state, action) => fp.function.compose(removeStatusLens.set('FETCHED'), selectedLens.set([]))(state);
methods[actionTypes.REMOVE_FAILED] = (state) => removeStatusLens.set('FAILED')(state);
methods[actionTypes.CLEAR] = (state) => (Object.assign({}, exports.initialState));
//#endregion
//# sourceMappingURL=projectUsers.js.map